import React from 'react';
import {withFormsy} from 'formsy-react';
import PropTypes from 'prop-types';
import Component from "./../Component";
import ScrollArea from "react-scrollbar";

class CheckboxGroupContainer extends Component {

    onChange(option) {
        let value;
        if (TB.isArray(this.props.value)) {
            value = [...this.props.value];
            value = TB.xorBy(value, [option], 'id');
        }

        return this.props.onChange(value)
    }

    getOptions() {
        return this.props.options;
    }

    render() {

        return (
            <div className="flex flex-col items-stretch">
                {this.props.label && (
                    <label className="col-form-label" data-required={this.props.required}>
                        {this.props.label}
                        {this.props.required && <span className="required-symbol"> *</span>}
                    </label>
                )}

                <ScrollArea
                    speed={0.8}
                    smoothScrolling={true}
                    stopScrollPropagation={true}
                    horizontal={false}>

                    {TB.map(this.getOptions() || [], (option, index) => {
                        let sectionOptions = [];
                        let displayValue = option.name || this.props.displayValue(option);

                        if (option.options) {
                            sectionOptions = TB.map(
                                option.options,
                                (cOption, cIndex) => {
                                    return this.renderOption(cOption, `${TB.slugify(index + cIndex)}`)
                                }
                            )
                            sectionOptions.unshift((
                                <p className={"checkbox-group-header " + displayValue} key={displayValue + '-header'}>
                                    {displayValue}
                                </p>
                            ))
                        } else {
                            sectionOptions = this.renderOption(option, index)
                        }

                        return sectionOptions;
                    })}

                </ScrollArea>
                {this.props.formErrors && (

                    <div className="help-text">
                        <p className="text-danger mb-0">
                            {this.props.formErrors}
                        </p>
                    </div>
                )}
            </div>
        );
    }

    renderOption(option, index) {
        let checked = TB.map(this.props.value, 'id').includes(option.id);

        let disabled = option.disabled;
        const optionName = TB.slugify("cbgroup" + option.id);
        return (
            <div
                key={`${this.props.name}-option-${option.id}-${index}`}
                className={TB.mapClass(
                    "checkbox-group-option",
                    {checked, disabled}
                )}>

                <div className={
                    TB.mapClass("form-checkbox", {
                        'disabled-checkbox': disabled
                    })
                }>
                    <input type="checkbox"
                           className="form-check-input"
                           name={optionName}
                           id={optionName}
                           required={false}
                           disabled={disabled}
                           onChange={() => this.onChange(option)}
                           checked={checked}/>

                    <label className="form-check-label" htmlFor={optionName}>
                        {this.props.displayValue?.(option) || option.name}
                    </label>

                </div>

            </div>
        )
    }
}

CheckboxGroupContainer.propTypes = {
    onChange: PropTypes.func,
    formErrors: PropTypes.any,
    options: PropTypes.any,
    disabled: PropTypes.any,
    value: PropTypes.any,
};

const CheckboxGroup = ({...props}) => {
    let errorMessage = props.getErrorMessage();

    let className = props.className || '';
    className += props.showRequired() ? ' required ' : '';

    className += !props.isValid() && props.isFormSubmitted() ? ' text-danger' : '';
    return (
        <div className={"form-group " + className}>
            <CheckboxGroupContainer
                {...props}
                value={props.getValue() || []}
                options={props.options}
                label={props.label}
                disabled={props.disabled}
                onReset={props.onReset ? () => props.onReset([]) : undefined}
                onChange={async (items) => {
                    // if (TB.keys(this.state.formErrors).length) {
                    //     await this.promisedState({formErrors: null})
                    // }

                    return props.setValue(items || [])

                }}
            />
            {errorMessage && (
                <span className={'mt-1 invalid-feedback position-relative'}>
                    {errorMessage}
                </span>
            )}
        </div>
    )
};


const CheckboxGroupInput = withFormsy(CheckboxGroup);
export {CheckboxGroupContainer};
export default CheckboxGroupInput;